export default __webpack_public_path__ + "static/TIMBERLINE-S-SERIES-24-C-Nav-WEB-d885e641cdeb21ef19f5bc5e521617f6.png";